module.exports = __webpack_public_path__ + "assets/Okta.7d02bd97.svg";